import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { preventMomentumScroll } from "components/Travel/function";

interface Props {
  title: string;
  children: JSX.Element;
  onOk: any;
}

const PopupFull: React.FunctionComponent<Props> = ({
  title,
  children,
  onOk
}) => {
  useEffect(() => {
    const modal: any = document.querySelector("#jsFullPopupInner");
    const modalSize: boolean = window.innerHeight > modal.scrollHeight;
    function handleTouchMove(e: any) {
      e.stopPropagation();
    }
    function handleTouchWindow(e: any) {
      e.preventDefault();
    }

    document.body.classList.add("scrollHidden");
    if (modalSize) {
      // 모달 내용이 짧을 때
      window.addEventListener("touchmove", handleTouchWindow, {
        passive: false
      });
    } else {
      modal.addEventListener("touchmove", handleTouchMove, { passive: false });
    }

    return () => {
      document.body.classList.remove("scrollHidden");
      if (modalSize) {
        window.removeEventListener("touchmove", handleTouchWindow);
      } else {
        window.removeEventListener("touchmove", handleTouchMove);
      }
    };
  });

  return (
    <Modal id="jsFullPopup">
      <ScrolledArea
        id="jsFullPopupInner"
        onScroll={e => preventMomentumScroll(e.currentTarget)}
        onTouchMove={e => {
          if (!preventMomentumScroll(e.currentTarget)) {
            e.stopPropagation();
          }
        }}
      >
        <div className="fullPopupContents">
          <Header>
            <h3>{title}</h3>
          </Header>
          <Body>{children}</Body>
        </div>
      </ScrolledArea>
      <ButtonConfirmWrap>
        <ButtonConfirm type="button" onClick={onOk}>
          확인
        </ButtonConfirm>
      </ButtonConfirmWrap>
    </Modal>
  );
};

const Modal = styled.article`
  z-index: 100;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  background-color: ${props => props.theme.colors.white};
  -webkit-overflow-scrolling: touch;
`;

const ScrolledArea = styled.div`
  overflow-y: scroll;
  max-height: 100%;

  .fullPopupContents {
    padding-bottom: 106px;
  }
`;

const Header = styled.header`
  padding: 40px 20px;
  font-size: ${props => props.theme.popup.sizeHeader};
  font-weight: ${props => props.theme.weight.bolder};
  line-height: 1.27;
  white-space: pre-line;
`;

const Body = styled.div`
  font-size: ${props => props.theme.text.sizeFont};
`;

const ButtonConfirmWrap = styled.div`
  z-index: 1;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
`;

const ButtonConfirm = styled.button`
  width: 100%;
  padding: 17px 10px;
  height: 56px;
  background: ${props => props.theme.buttonPrimary.colorBg};
  color: ${props => props.theme.buttonPrimary.colorFont};
  font-size: ${props => props.theme.buttonPrimary.sizeFont};
  font-weight: ${props => props.theme.weight.bolder};
  line-height: 22px;
`;

export default PopupFull;
